module.exports = __webpack_public_path__ + "static/media/logoAllas.f9fab192.png";